(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile--collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Type definitions
  /** @type {NodeListOf<Element>} */
  const accordionItems = document.querySelectorAll('.accordion-item');
  /** @type {HTMLInputElement | null} */
  const searchInput = document.getElementById('collectionSearch');
  /** @type {HTMLElement | null} */
  const collectionList = document.querySelector('.collection-list');

  // Add no results message
  if (collectionList) {
    const noResultsMessage = document.createElement('div');
    noResultsMessage.className = 'no-results-message';
    noResultsMessage.textContent = 'No destinations found matching your search';
    collectionList.insertAdjacentElement('afterend', noResultsMessage);
  }

  // Accordion functionality
  accordionItems.forEach(item => {
    const header = item.querySelector('.collection-item-header');
    if (header) {
      header.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        
        // Close all accordion items
        accordionItems.forEach(otherItem => {
          otherItem.classList.remove('active');
        });
        
        // Toggle current item
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });

  // Search functionality
  if (searchInput) {
    /**
     * Debounce function to limit the rate at which the search is performed
     * @template T
     * @param {(...args: any[]) => void} func 
     * @param {number} wait 
     * @returns {(...args: any[]) => void}
     */
    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    /**
     * Reset element to its original state
     * @param {Element} element 
     */
    const resetElement = (element) => {
      element.style.display = '';
      element.classList.remove('active', 'search-match');
    };

    /**
     * Perform search across all items
     * @param {string} searchTerm 
     */
    const performSearch = (searchTerm) => {
      const normalizedSearchTerm = searchTerm.toLowerCase().trim();
      const items = document.querySelectorAll('.collection-item');
      let hasResults = false;

      items.forEach(item => {
        const titleElement = item.querySelector('.collection-item-title span');
        const subItemsList = item.querySelector('.subcollection-list');
        const subItems = Array.from(item.querySelectorAll('.subcollection-item'));
        
        if (!titleElement) return;

        if (normalizedSearchTerm === '') {
          // Reset state for main item
          resetElement(item);
          
          // Reset state for all subitems
          subItems.forEach(subItem => {
            resetElement(subItem);
            subItem.style.display = '';
          });

          if (subItemsList) {
            subItemsList.style.display = '';
          }
        } else {
          const title = titleElement.textContent?.toLowerCase() || '';
          const matchesMainTitle = title.includes(normalizedSearchTerm);
          
          // Check subitems for matches
          const matchingSubItems = subItems.filter(subItem => {
            const subItemText = subItem.querySelector('span')?.textContent?.toLowerCase() || '';
            return subItemText.includes(normalizedSearchTerm);
          });

          if (matchesMainTitle || matchingSubItems.length > 0) {
            // Show main item if it matches
            hasResults = true;
            item.style.display = '';
            item.classList.add('search-match');

            // Handle subitems
            if (subItemsList) {
              subItemsList.style.display = 'block';
              item.classList.add('active');

              // Process each subitem
              subItems.forEach(subItem => {
                const subItemSpan = subItem.querySelector('span');
                const subItemText = subItemSpan?.textContent?.toLowerCase() || '';
                
                if (subItemText.includes(normalizedSearchTerm)) {
                  // Show matching subitems
                  subItem.style.display = '';
                } else {
                  // Hide non-matching subitems
                  subItem.style.display = 'none';
                }
              });
            }
          } else {
            // Hide non-matching main items
            item.style.display = 'none';
            item.classList.remove('search-match', 'active');
          }
        }
      });

      // Show/hide no results message
      const noResultsMessage = document.querySelector('.no-results-message');
      if (noResultsMessage) {
        noResultsMessage.classList.toggle('show', normalizedSearchTerm !== '' && !hasResults);
      }
    };

    // Add event listener with debounce
    searchInput.addEventListener('input', debounce((e) => {
      try {
        const target = e.target;
        if (target instanceof HTMLInputElement) {
          performSearch(target.value);
        }
      } catch (error) {
        console.error('Search error:', error);
        // Reset search state on error
        performSearch('');
      }
    }, 300));

    // Clear search on escape key
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchInput.value = '';
        performSearch('');
      }
    });
  }

  // Update view details toggle functionality
  const viewDetailsButtons = document.querySelectorAll('[data-toggle-details]');
  
  viewDetailsButtons.forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.id.split('-').pop();
      const expandedDetails = document.getElementById(`card-expanded-details-${productId}`);
      
      this.classList.toggle('active');
      if (expandedDetails.style.display === 'none') {
        expandedDetails.style.display = 'block';
      } else {
        expandedDetails.style.display = 'none';
      }
    });
  });

  // Mobile Filter Popup Functionality
  const filterTrigger = document.getElementById('mobile-filter-trigger');
  const filterPopup = document.querySelector('.mobile-filter-popup');
  const filterOverlay = document.querySelector('.mobile-filter-popup-overlay');
  const closeFilterBtn = document.querySelector('.close-filter-popup');
  const filterContent = document.querySelector('.mobile-filter-popup-content');

  if (filterTrigger && filterPopup && filterOverlay && closeFilterBtn) {
    // Open filter popup
    filterTrigger.addEventListener('click', function() {
      filterPopup.classList.add('active');
      filterOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    // Close filter popup
    function closeFilterPopup() {
      filterPopup.classList.remove('active');
      filterOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeFilterBtn.addEventListener('click', closeFilterPopup);
    filterOverlay.addEventListener('click', closeFilterPopup);

    // Handle filter changes
    filterContent.addEventListener('change', function(e) {
      if (e.target.matches('input[type="checkbox"]')) {
        updateSelectedFilters();
        updateFilteredProducts();
      }
    });

    // Update filtered products
    function updateFilteredProducts() {
      const productCards = document.querySelectorAll('.card--holder');
      const selectedDataFilters = Array.from(document.querySelectorAll('.data-filter input[type="checkbox"]:checked')).map(cb => cb.value);
      const selectedValidityFilters = Array.from(document.querySelectorAll('.validity-filter input[type="checkbox"]:checked')).map(cb => cb.value);

      productCards.forEach(card => {
        const dataValue = card.getAttribute('data-custom-field');
        const validityValue = card.getAttribute('validity-custom-field');
        let shouldShow = true;

        if (selectedDataFilters.length > 0) {
          shouldShow = shouldShow && selectedDataFilters.some(filter => dataValue.includes(filter));
        }

        if (selectedValidityFilters.length > 0) {
          shouldShow = shouldShow && selectedValidityFilters.some(filter => validityValue.includes(filter));
        }

        card.style.display = shouldShow ? '' : 'none';
      });

      // Update no products message
      const noProductsMessage = document.querySelector('.no-products-message');
      const visibleProducts = document.querySelectorAll('.card--holder[style=""]').length;
      
      if (noProductsMessage) {
        noProductsMessage.style.display = visibleProducts === 0 ? 'block' : 'none';
      }
    }

    // Update selected filters display
    function updateSelectedFilters() {
      const selectedFiltersContainer = document.querySelector('.selected-filters');
      const clearAllButton = document.querySelector('.clear-all-filters');
      
      if (selectedFiltersContainer && clearAllButton) {
        selectedFiltersContainer.innerHTML = '';
        const checkedFilters = document.querySelectorAll('.select-option input[type="checkbox"]:checked');
        
        clearAllButton.style.display = checkedFilters.length > 0 ? 'block' : 'none';

        checkedFilters.forEach(filter => {
          const filterValue = filter.value;
          const filterElement = document.createElement('div');
          filterElement.className = 'selected-filter';
          filterElement.innerHTML = `
            <span>${filterValue}</span>
            <button type="button" aria-label="Remove filter">×</button>
          `;

          filterElement.querySelector('button').addEventListener('click', () => {
            filter.checked = false;
            updateSelectedFilters();
            updateFilteredProducts();
          });

          selectedFiltersContainer.appendChild(filterElement);
        });
      }
    }

    // Clear all filters
    const clearAllButton = document.querySelector('.clear-all-filters');
    if (clearAllButton) {
      clearAllButton.addEventListener('click', function() {
        document.querySelectorAll('.select-option input[type="checkbox"]:checked').forEach(cb => {
          cb.checked = false;
        });
        updateSelectedFilters();
        updateFilteredProducts();
      });
    }
  }

  // Custom select functionality
  const customSelects = document.querySelectorAll('.custom-select');
  
  customSelects.forEach(select => {
    const selected = select.querySelector('.select-selected');
    const items = select.querySelector('.select-items');
    
    if (selected && items) {
      selected.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Close other selects
        customSelects.forEach(otherSelect => {
          if (otherSelect !== select) {
            const otherSelected = otherSelect.querySelector('.select-selected');
            const otherItems = otherSelect.querySelector('.select-items');
            if (otherSelected && otherItems) {
              otherSelected.classList.remove('active');
              otherItems.classList.remove('active');
              otherItems.classList.add('select-hide');
            }
          }
        });

        // Toggle current select
        selected.classList.toggle('active');
        items.classList.toggle('active');
        items.classList.toggle('select-hide');
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.custom-select')) {
      customSelects.forEach(select => {
        const selected = select.querySelector('.select-selected');
        const items = select.querySelector('.select-items');
        if (selected && items) {
          selected.classList.remove('active');
          items.classList.remove('active');
          items.classList.add('select-hide');
        }
      });
    }
  });

  // Handle filter action buttons
  const resetFilterBtn = document.querySelector('.filter-action-button.reset');
  const applyFilterBtn = document.querySelector('.filter-action-button.apply');

  if (resetFilterBtn) {
    resetFilterBtn.addEventListener('click', function() {
      // Reset all checkboxes
      document.querySelectorAll('.filter-checkbox:checked').forEach(cb => {
        cb.checked = false;
      });
      
      // Update selected filters display
      updateSelectedFilters();
      
      // Reset product display
      updateFilteredProducts();
    });
  }

  if (applyFilterBtn) {
    applyFilterBtn.addEventListener('click', function() {
      // Close the filter popup
      const filterPopup = document.querySelector('.mobile-filter-popup');
      const filterOverlay = document.querySelector('.mobile-filter-popup-overlay');
      
      if (filterPopup && filterOverlay) {
        filterPopup.classList.remove('active');
        filterOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
